export default {"src":"/_next/static/media/icon-wand.aaf04bc0.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};